import { render, staticRenderFns } from "./CompanyAgenda.vue?vue&type=template&id=2e77c9b2&"
import script from "./CompanyAgenda.vue?vue&type=script&lang=js&"
export * from "./CompanyAgenda.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports